/**
 * 
 * Footer.js
 * 
 */


 import React, { Component } from 'react'
import { Navbar, Col, Row } from 'react-bootstrap';
 
 export default class Footer extends Component {

    static displayName = Footer.name;

     render() {

         return (
        

            <Navbar id="contactus" style={{ backgroundColor: "", width: '120%', borderTop: "1px solid  #d3d3d3" }} className=""  expand="lg"  variant="dark">


                    <Navbar.Brand style={{ paddingLeft: '' }}>

                        <Row>
                        
                            <Col>
                                <p style={{ color: 'black', fontSize: '14px' }}>
                                    <p style={{ fontSize: '20px' }}>Contact Us</p>
                                    <b>Email:</b> <a href="mailto:mmengesha555@gmail.com">mmengesha555@gmail.com</a> | <a href="mailto:clarke.dhana46@gmail.com">clarke.dhana46@gmail.com</a> 
                                    <br />
                                    <b>Phone:</b> <font color="#156fa1">+251 91 136 7727 | +254 742 355 400</font>
                                    <br />
                                    <b>Telegram contact:</b> <a href="https://t.me/Muluk9n">@Muluk9n</a>
                                </p>
                            </Col>

                            <Col lg style={{ paddingLeft: '150px' }}>

                                <p style={{ color: "black", fontSize:' 20px' }}>
                                    Our Projects
                                </p>
                                <p style={{ fontSize: '14px' }}>
                                    <a href="https://t.me/Covid_robot">Smile Covid-19 tracker</a>
                                </p>


                            </Col>
                        
                        </Row>

                    </Navbar.Brand>

                
            </Navbar>
        

         );

     }

 }

 
